import React from 'react'
import About from '../components/About/About'
import Facts from '../components/About/Facts'
import Feature from '../components/Services/Feature'
import SecondBanner from '../components/Banner/SecondBanner'

const about = () => {
  return (
    <>
    <SecondBanner title="About Us" breadcrumbText="About" />
    <About showButton={false} />
    <Facts/>
    <Feature/>
    </>
  )
}

export default about